import { useMutation } from '@tanstack/react-query';
import {
  GenQrBidvVAEntity,
  GenQrBidvVADto,
  BidvVirtualAccountService,
} from 'services/openapi';

export const useGenQrBidvVAMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      GenQrBidvVAEntity,
      Error,
      { vaPrefix: string; endCode: string; requestBody?: GenQrBidvVADto }
    >({
      mutationFn: (variables) => {
        return BidvVirtualAccountService.bidvVaControllerGenQr(
          variables.vaPrefix,
          variables.endCode,
          variables.requestBody,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
